import React from "react";

export default () => (
  <header>
    <a href="https://numacinema.xemono.life/lp/" target="_brank" rel="noopener">
      <h1>numaflow</h1>
    </a>
  </header>
);
